export enum PetitionTypeId {
  ACADEMIC = 'ACD',
  OTHER = 'OTH',
  PAYMENT = 'PAY',
  PROFICIENCY = 'PRO',
  REPLACE_COURSE_GRADE = 'RCG',
  REPLACE_EVALUATION_GRADE = 'REG',
  VALIDATION = 'VAL',
  SUBJECT_ASSIGNMENT = 'ADA',
  HOMOLOGATION = 'HOM',
}

export enum PetitionPaymentTypeId {
  BY_CREDIT = 'CREDIT',
  BY_FIXED = 'FIXED',
}

export interface PetitionType {
  id: PetitionTypeId;
  name: string;
  paymentRequired?: boolean | null;
  paymentAmount?: number | null;
  paymentType?: PetitionPaymentTypeId | null;
}

export interface CertificateType {
  id: number;
  name: string;
  paymentRequired?: boolean | null;
  paymentAmount?: number | null;
}

export interface AcademicLevelType {
  id: number;
  code: string;
  name: string;
  titulationPaymentId?: number | null;
  paymentRequired?: boolean | null;
  paymentAmount?: number | null;
}

export interface PricingFormDataResponse {
  certificateTypes: CertificateType[];
  petitionTypes: PetitionType[];
  petitionPaymentTypes: { name: string; id: PetitionPaymentTypeId }[];
  academicLevels: AcademicLevelType[];
}

export interface StudyPlanTitulationRow {
  studyPlanId: number;
  name: string;
  modalityName: string | null;
  hasOverride: boolean;
  paymentAmount: number | null;
  disabled?: boolean;
}

export interface StudyPlanTitulationDetail {
  titulationPaymentId: number | null;
  paymentRequired: boolean;
  paymentAmount: number | null;
  studyPlans: StudyPlanTitulationRow[];
}
